<template>
  <JobDetailModal :job="selectedJob" :visible="modalVisible" @close="modalVisible = false" />
  <div class="admin-box">
    <div class="tab-bar">
      <button :class="{ active: activeTab === 'approved' }" @click="activeTab = 'approved'">Onaylı Tercümanlar</button>
      <button :class="{ active: activeTab === 'pending' }" @click="activeTab = 'pending'">Onay Bekleyenler</button>
    </div>

    <!-- ✅ ONAYLI TERCÜMANLAR -->
    <div v-if="activeTab === 'approved'">
      <h2>✅ Onaylanmış Tercümanlar</h2>
      <div v-if="approved.length === 0">Onaylanmış tercüman yok.</div>

      <div v-for="t in approved" :key="t.id" class="translator-card approved">
        <h3 @click="toggleExpand(t.id)" class="clickable-name">{{ t.name }}</h3>
        <p><strong>E-posta:</strong> {{ t.email }}</p>
        <p><strong>Diller:</strong> {{ t.languages }}</p>

        <div v-if="expandedTranslatorId === t.id" class="translator-details">
          <p><strong>Telefon:</strong> {{ t.phone || 'Belirtilmemiş' }}</p>
          <p><strong>Deneyim:</strong> {{ t.experience || 'Belirtilmemiş' }}</p>
          <p>
            <strong>CV:</strong>
            <a v-if="t.cv_file" :href="`${baseURL}/uploads/cv/${t.cv_file}`" target="_blank" rel="noopener noreferrer">Görüntüle</a>
            <span v-else>Yüklenmemiş</span>
          </p>

          <p>
            <strong>Sertifikalar:</strong>
            <template v-if="t.certificates">
              <span
                v-for="(cert, index) in t.certificates.split(',')"
                :key="index"
              >
                <a
                  :href="`${baseURL}/uploads/certificates/${cert}`"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ formatFileName(cert) }}
                </a>
                <span v-if="index < t.certificates.split(',').length - 1">, </span>
              </span>
            </template>
            <span v-else>Yüklenmemiş</span>
          </p>
          <p><strong>Üniversite:</strong> {{ (t.university_name && t.university_department) ? t.university_name + ' / ' + t.university_department : 'Belirtilmemiş' }}</p>
          <p><strong>Açıklama:</strong> {{ t.description || 'Yok' }}</p>

          <template v-if="t.jobs && t.jobs.length">
            <!-- 🟡 Devam Eden İşler -->
            <h4>🟡 Devam Eden İşler</h4>
            <table class="job-table" v-if="t.jobs.some(j => j.status !== 'completed')">
              <thead>
                <tr>
                  <th>İş Kodu</th>
                  <th>Teslim Tarihi</th>
                  <th>Durum</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="job in t.jobs.filter(j => j.status !== 'completed')" :key="job.id">
                  <tr @click="toggleJobExpand(job.id)" class="clickable-row">
                    <td>{{ job.code }}</td>
                    <td>{{ formatDate(job.delivery_date) }}</td>
                    <td>{{ translateStatus(job.status) }}</td>
                  </tr>
                  <tr v-if="expandedJobId === job.id">
                    <td colspan="3">
                      <div class="job-detail">
                        <p><strong>Açıklama:</strong> {{ job.description || 'Yok' }}</p>
                        <p><strong>Kullanıcı:</strong> {{ job.user_name || 'Bilinmiyor' }}</p>
                        <p><strong>Tercüme Türü:</strong> {{ job.translation_type || '-' }}</p>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>

            <!-- ✅ Tamamlanan İşler -->
            <h4>✅ Tamamlanan İşler</h4>
            <table class="job-table" v-if="t.jobs.some(j => j.status === 'completed')">
              <thead>
                <tr>
                  <th>İş Kodu</th>
                  <th>Teslim Tarihi</th>
                  <th>Durum</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="job in t.jobs.filter(j => j.status === 'completed')" :key="job.id">
                  <tr @click="toggleJobExpand(job.id)" class="clickable-row">
                    <td>{{ job.code }}</td>
                    <td>{{ formatDate(job.delivery_date) }}</td>
                    <td>{{ translateStatus(job.status) }}</td>
                  </tr>
                  <tr v-if="expandedJobId === job.id">
                  <td colspan="3">
                    <div class="job-detail">
                      <p><strong>Açıklama:</strong> {{ job.description || 'Yok' }}</p>
                      <p><strong>Kullanıcı:</strong> {{ job.user_name || 'Bilinmiyor' }}</p>
                      <p><strong>Tercüme Türü:</strong> {{ job.translation_type || '-' }}</p>

                      <p><strong>Belge:</strong> 
                        <a v-if="job.file_name" :href="`${baseURL}/uploads/${job.file_name}`" target="_blank">İndir</a>
                        <span v-else>Yok</span>
                      </p>

                      <p><strong>Çıktı Dosyaları:</strong>
                        <template v-if="job.output_files && job.output_files.length">
                          <ul>
                            <li v-for="(file, index) in job.output_files" :key="index">
                              <a :href="`${baseURL}/uploads/output/${file}`" target="_blank">{{ file }}</a>
                            </li>
                          </ul>
                        </template>
                        <span v-else>Yok</span>
                      </p>

                      <p><strong>Yükleme Tarihi:</strong> {{ formatDate(job.output_upload_date) || 'Belirtilmemiş' }}</p>

                      <p><strong>Ödeme:</strong>
                        <span :style="{ color: job.is_paid ? 'green' : 'red' }">
                          {{ job.is_paid ? 'Ödendi' : 'Bekleniyor' }}
                        </span>
                      </p>

                      <p><strong>Kullanıcı:</strong> {{ job.user_name }} {{ job.user_surname }}</p>

                      <p>
                        <button class="file-link" @click="openModal(job)">İşi Aç</button>
                      </p>
                    </div>
                  </td>
                </tr>
                </template>
              </tbody>
            </table>
          </template>

          <div v-else>Bu tercümana ait iş bulunamadı.</div>
        </div>

        <div class="button-group">
          <button @click="remove(t.id)">🗑️ Sil</button>
        </div>
      </div>
    </div>

    <!-- 🕓 ONAY BEKLEYEN TERCÜMANLAR -->
    <div v-if="activeTab === 'pending'">
      <h2>🕓 Onay Bekleyen Tercümanlar</h2>
      <div v-if="pending.length === 0">Bekleyen tercüman yok.</div>

      <div v-for="t in pending" :key="t.id" class="translator-card">
        <h3>{{ t.name }}</h3>
        <p><strong>Eğitim:</strong> {{ t.education_level }}</p>
        <p v-if="t.education_level === 'lisans'">
          <strong>Üniversite:</strong> {{ t.university_name }} / {{ t.university_department }}
        </p>
        <p><strong>Deneyim:</strong> {{ t.experience || 'Belirtilmemiş' }}</p>
        <p><strong>Diller:</strong> {{ t.languages || 'Belirtilmemiş' }}</p>

        <p>
          <strong>CV:</strong>
          <a v-if="t.cv_file" :href="`${baseURL}/${t.cv_file}`" target="_blank">Görüntüle</a>
          <span v-else>Yüklenmemiş</span>
        </p>
          <p>
            <strong>Sertifikalar:</strong>
            <template v-if="t.certificates && t.certificates.length">
              <ul>
                <li v-for="(cert, i) in t.certificates" :key="i">
                  <a :href="`${baseURL}/${cert.file_path}`" target="_blank">
                    {{ formatFileName(cert.file_name) }}
                  </a>
                </li>
              </ul>
            </template>
            <span v-else>Yüklenmemiş</span>
          </p>
        <div class="button-group">
          <button @click="approve(t.id)">✅ Onayla</button>
          <button @click="reject(t.id)">❌ Reddet</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getToken } from '@/utils/auth'
import JobDetailModal from '@/components/JobDetailModal.vue'
const baseURL = process.env.VUE_APP_API_URL
const pending = ref([])
const approved = ref([])
const activeTab = ref('approved')
const expandedTranslatorId = ref(null)
const expandedJobId = ref(null)
const modalVisible = ref(false)
const selectedJob = ref(null)

defineProps({
  pendingTranslators: Array,
  fetchData: Function
})

function toggleExpand(id) {
  expandedTranslatorId.value = expandedTranslatorId.value === id ? null : id

  if (expandedTranslatorId.value !== null) {
    loadJobsForTranslator(id)
  }
}
function toggleJobExpand(jobId) {
  expandedJobId.value = expandedJobId.value === jobId ? null : jobId
}
function openModal(job) {
  selectedJob.value = job
  modalVisible.value = true
}
function translateStatus(status) {
  switch (status) {
    case 'in_progress':
      return 'Çeviride'
    case 'completed':
      return 'Tamamlandı'
    case 'waiting':
      return 'Bekliyor'
    case 'assigned':
      return 'Atandı'
    default:
      return status
  }
}

async function fetchTranslators() {
  const resPending = await fetch(`${baseURL}/admin/translators/pending`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  pending.value = await resPending.json()

  const resApproved = await fetch(`${baseURL}/admin/translators/approved`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  approved.value = await resApproved.json()
}

async function approve(id) {
  try {
    const res = await fetch(`${baseURL}/admin/translator/${id}/approve`, {
      method: 'PUT',
      headers: { 
        'Authorization': `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      const error = await res.json()
      alert('Onaylama başarısız: ' + error.message)
      return
    }
    fetchTranslators()
  } catch (error) {
    alert('Sunucu hatası: ' + error.message)
  }
}

async function reject(id) {
  try {
    const res = await fetch(`${baseURL}/admin/translator/${id}/reject`, {
      method: 'PUT',
      headers: { 
        'Authorization': `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      }
    })
    if (!res.ok) {
      const error = await res.json()
      alert('Reddetme başarısız: ' + error.message)
      return
    }
    fetchTranslators()
  } catch (error) {
    alert('Sunucu hatası: ' + error.message)
  }
}

async function remove(id) {
  const confirmDelete = confirm('Tercümanı silmek istediğinize emin misiniz?')
  if (!confirmDelete) return

  await fetch(`${baseURL}/admin/translator/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  fetchTranslators()
}
async function loadJobsForTranslator(id) {
  const res = await fetch(`${baseURL}/admin/translator/${id}/jobs`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  })
  const jobs = await res.json()

  const translator = approved.value.find(t => t.id === id)
  if (translator) {
    translator.jobs = jobs
  }
}
function formatDate(dateString) {
  if (!dateString) return ''
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}-${month}-${year} ${hours}:${minutes}`
}
function formatFileName(fileName) {
  return fileName?.split('-').slice(1).join('-') || fileName
}

onMounted(fetchTranslators)
</script>

<style scoped>
.admin-box {
  max-width: 700px; /* Daha dar yapı */
  margin: 80px auto 40px auto; /* Header'dan boşluk + ortalama */
  padding: 20px;
  background-color: #ffffff93;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.tab-bar {
  text-align: center;
  margin-bottom: 20px;
}
h2 {
  text-align: center;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* İstediğin fontu buraya ekle */
  font-weight: 600;
  font-size: 1.8rem;
  margin-bottom: 20px;
  color: #2c3e50;
}
.tab-bar button {
  padding: 10px 20px;
  margin: 5px;
  background: #eee;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}
.tab-bar .active {
  background: #3498db;
  color: white;
}
.translator-card {
  border: 1px solid #ddd;
  padding: 12px 16px;
  font-size: 14px;
  margin-bottom: 20px;
  border-radius: 8px;
  background: #fafafa;
  color: #222;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.translator-card h3 {
  font-size: 16px;
}
.translator-card.approved {
  background: #f0f9f0;
}
.clickable-name {
  color: #2c3e50;
  cursor: pointer;
}
.clickable-name:hover {
  text-decoration: underline;
}
.button-group {
  margin-top: 10px;
}
button {
  margin-right: 10px;
  padding: 6px 12px;
  cursor: pointer;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
}
button:hover {
  background-color: #2980b9;
}

.job-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
}

.job-table th,
.job-table td {
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 13px;
  text-align: left;
}

.job-table th {
  background-color: #f0f0f0;
}

.clickable-row {
  cursor: pointer;
  background-color: #fdfdfd;
}
.clickable-row:hover {
  background-color: #f3faff;
}
.job-detail {
  background: #f9f9f9;
  padding: 10px;
  font-size: 14px;
  border-top: 1px solid #ddd;
}
.job-link {
  text-decoration: underline;
  color: #0077cc;
  font-weight: bold;
}
.job-link:hover {
  color: #005299;
}
@media (max-width: 768px) {
  .admin-box {
    padding: 16px;
    margin: 60px 12px;
    width: auto;
  }

  .tab-bar {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .tab-bar button {
    width: 100%;
    margin-bottom: 8px;
    font-size: 15px;
  }

  .translator-card {
    font-size: 13px;
    padding: 10px;
  }

  .translator-card h3 {
    font-size: 15px;
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  button {
    width: 100%;
    font-size: 14px;
    padding: 10px;
  }

  .job-table,
  .job-table thead,
  .job-table tbody,
  .job-table th,
  .job-table td,
  .job-table tr {
    display: block;
    width: 100%;
  }

  .job-table tr {
    margin-bottom: 12px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .job-table td {
    padding: 10px;
    font-size: 13px;
    display: flex;
    justify-content: space-between;
    border: none;
    border-bottom: 1px solid #eee;
  }

  .job-table th {
    display: none;
  }

  .job-detail {
    font-size: 13px;
    padding: 8px;
  }
}

</style>